<script setup lang="ts">
const src = 'https://rriemann.uber.space/piwik/index.php?module=CoreAdminHome&action=optOutJS&divId=matomo-opt-out'

// Load the opt-out script client-side only, after the target div is in the DOM
onMounted(() => {
  const script = document.createElement('script')
  script.src = src
  script.defer = true
  document.body.appendChild(script)
  onBeforeUnmount(() => script.remove())
})
</script>

<template>
  <div id="matomo-opt-out" />
</template>
